const absolutePath = (_url: string) => {
  if(_url.includes('https://')) {
    return _url;
  }
  const { baseUrl } = useRuntimeConfig().public;
  return `${baseUrl}${_url}`;
}
export default absolutePath;
